import { render, staticRenderFns } from "./dadutouhetong.vue?vue&type=template&id=5b9e6a7c&scoped=true&"
import script from "./dadutouhetong.vue?vue&type=script&lang=js&"
export * from "./dadutouhetong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9e6a7c",
  null
  
)

export default component.exports